import { render, staticRenderFns } from "./public_.vue?vue&type=template&id=2d3d16e2&scoped=true"
import script from "./public_.vue?vue&type=script&lang=js"
export * from "./public_.vue?vue&type=script&lang=js"
import style0 from "./public_.vue?vue&type=style&index=0&id=2d3d16e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3d16e2",
  null
  
)

export default component.exports